import { COLORS, THEMES } from '../helpers/config';

export const DEFAULT_COLOR = COLORS.green;
export const DEFAULT_MODE = THEMES.DARK;
